import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import MeetTheBros from "./components/MeetTheBros";
import ServiceFeatures from "./components/ServiceFeatures";
import WeLoanOn from "./components/WeLoanOn";
import ProblemSection from "./components/ProblemSection";
import StatsSection from "./components/StatsSection";
import SolutionSection from "./components/SolutionSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import EquipmentPage from "./pages/EquipmentPage";
import TeamPage from "./pages/TeamPage";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <MeetTheBros />
      <ServiceFeatures />
      <WeLoanOn />
      <ProblemSection />
      <StatsSection />
      <SolutionSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/equipment/:slug" element={<EquipmentPage />} />
          <Route path="/team" element={<TeamPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
